import { commonTypes } from './common';

export const types = {
  SAVE_NEXT_STEPS_DATA: 'NEXT_STEPS/SAVE_NEXT_STEPS_DATA',
};

export const resetState = {
  nextStepsDataInfo: [],
};

const nextStepsFromSession = JSON.parse(sessionStorage.getItem('nextStepsDataInfo'));
const initialState = { ...resetState };
if (nextStepsFromSession) {
  if (window && window.location && window.location.pathname.indexOf('confirmacion') !== -1) {
    initialState.nextStepsDataInfo = nextStepsFromSession;
  } else {
    sessionStorage.removeItem('nextStepsDataInfo');
  }
}

// eslint-disable-next-line @typescript-eslint/default-param-last
const NextStepsReducer = (state = initialState, action) => {
  switch (action.type) {
    case commonTypes.RESET_FLOW: {
      return {
        nextStepsDataInfo: [],
      };
    }
    case commonTypes.SET_INIT_FLOW: {
      return {
        ...resetState,
      };
    }
    case types.SAVE_NEXT_STEPS_DATA: {
      const nextStepsDataInfo = [...state.nextStepsDataInfo, ...action.payload];
      sessionStorage.setItem('nextStepsDataInfo', JSON.stringify(nextStepsDataInfo));
      return {
        ...state,
        nextStepsDataInfo,
      };
    }
    default:
      return state;
  }
};

export const actions = {
  saveNextStepsData: data => ({
    type: types.SAVE_NEXT_STEPS_DATA,
    payload: data,
  }),
};

export default NextStepsReducer;
